import { getOrgId } from '../local-ids/get-org-id';

export interface GetCollectionPathInput {
  Deserializer: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export const getCollectionPath = async ({ Deserializer }: GetCollectionPathInput) => {
  const orgId = await getOrgId();
  const collectionPath = Deserializer.getSchema().getCollection(orgId);

  return collectionPath;
};
